import { API } from 'aws-amplify';

export default {
  onTenderChanged(mpID) {
    const query = `subscription onTenderChanged($mpID: String) {
      onTenderChanged(mpID: $mpID) {
        mpID
        status
      }
    }`;

    return API.graphql({
      query,
      variables: {
        mpID,
      },
    }).map(({ value }) => {
      return value.data.onTenderChanged;
    });
  },

  onBidChanged(mpID) {
    const query = `subscription onBidChanged($mpID: String) {
      onBidChanged(mpID: $mpID) {
        mpID
        status
      }
    }`;

    return API.graphql({
      query,
      variables: {
        mpID,
      },
    }).map(({ value }) => {
      return value.data.onBidChanged;
    });
  },

  onAwardChanged(mpID) {
    const query = `subscription onAwardChanged($mpID: String) {
      onAwardChanged(mpID: $mpID) {
        mpID
        status
      }
    }`;

    return API.graphql({
      query,
      variables: {
        mpID,
      },
    }).map(({ value }) => {
      return value.data.onAwardChanged;
    });
  }
}
